<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Insight Job: {{ failedJob.job_id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <div class="row">
      <div class="col-auto">
        <h4 i18n>Job name</h4>
        <p>{{ failedJob.job_name }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-auto">
        <h4 i18n>Date Created</h4>
        <p>{{ failedJob.date_created | date : 'short' }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-auto">
        <h4 i18n>Job Status</h4>
        <p>{{ failedJob.status }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-auto">
        <h4 i18n>Reason For Failure</h4>
        <p>{{ failedJob.job_status.status_reason }}</p>
      </div>
    </div>

    <div class="row">
      <!-- <hr> -->
      <div class="col-auto">
        <h4 i18n>List Of Job Logs</h4>
        <div style="overflow: auto">
          <div *ngIf="showLogs">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col" i18n>Log Number</th>
                  <th scope="col" i18n>Ingestion Time</th>
                  <th scope="col" i18n>Message</th>
                  <th scope="col" i18n>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let failedJob of failedJob.job_logs; index as i">
                  <th scope="row">{{ i + 1 }}</th>
                  <td>
                    {{ failedJob.ingestionTime | date : 'short' }}
                  </td>
                  <td>{{ failedJob.message }}</td>
                  <td>{{ failedJob.timestamp | date : 'short' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="!showLogs" i18n>Logs not found.</div>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton status="info" (click)="close()" i18n>Close</button>
    </div>
  </nb-card-footer>
</nb-card>
